<template>
  <button :class="`${size}`">
    <div
      v-if="!!$slots['icon']"
      :class="`icon ${!$slots.default ? '' : 'mr'}`"
    >
      <slot name="icon" />
    </div>
    <span class="text">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'sm',
    }
  },
}
</script>

<style lang="scss" scoped>
button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 185px;
  background-color: #37B2A8;
  color: white;
  border: 2px solid #37B2A8;
  border-radius: 0.75rem;
  line-height: 1;
  letter-spacing: -0.5px;
  transition: .25s;

  &:hover {
    background-color: #0A8080;
    border-color: #0A8080;
  }

  &.sm {
    font-size: 14px;
    padding: 0.25rem 1.5rem;
  }

  &.md {
    font-size: 16px;
    padding: .75rem 1.5rem;
  }

  &.lg {
    font-size: 18px;
    padding: 1.5rem;
  }

  .icon {
    &.mr {
      margin-right: .5rem;
    }

    :deep(path) {
      stroke: #FFFFFF;
    }
  }
}
</style>
